module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xydHWc/images/cover.jpg?1684514917790",
      "alt": "This image is the cover for the book Troubleshooting: A Technician's Guide, Second Edition"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Troubleshooting: A Technician's Guide, Second Edition\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Troubleshooting loops and systems is something all technicians must do, but that few truly master. This edition draws on the author’s long experience as an instrument and electrical engineer and his maintenance expertise to provide a detailed look at the skills and knowledge required for troubleshooting. Interspersed with a wealth of practical detail and real-world examples are Mostia’s no-nonsense discussions of what a good troubleshooter needs to know. He provides an in-depth discussion of the basic logical framework that underlies all troubleshooting as well as advanced troubleshooting techniques. He also explores the causes of failures and the techniques that engineers and technicians use to trace them down. This edition covers troubleshooting methods, both basic and advanced, hints and troubleshooting aids, troubleshooting safety, basic maintenance concepts, information about training, and the developing troubleshooting skills. It also includes numerous examples of troubleshooting problems in mechanical systems, process connections, pneumatic systems, electrical systems, electronic systems, and valves. Mostia also explores test equipment, programmable electronic systems, communication circuits, transient problems, and software. - See more at: https://www.isa.org/store/products/product-detail/?productId=116195#sthash.CjIr9eVF.dpuf")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William L. Mostia,Jr.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    International Society of Automation\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0